/**
 * 記事編集画面のフィールドのドラッグ&ドロップを無効化します。
 *
 * @requires jQuery
 * @param {Object} [options={}] - オプションのオブジェクト
 * @param {boolean} [options.hideDisplayOptions=false] - trueをセットすると#display-optionsを非表示にする
 */
export function sortDisabled(options = {}) {
    const { hideDisplayOptions = false } = options;

    const sortable = document.getElementById('sortable');
    if (sortable) {
        jQuery(sortable).sortable({ disabled: true });

        const fields = sortable.querySelectorAll('div.sort-enabled');
        fields.forEach((field) => {
            field.classList.remove('sort-enabled');
            const svgElement = field.querySelector('svg');
            if (svgElement && svgElement.parentElement) {
                const nextSibling = svgElement.parentElement.nextElementSibling;
                if (nextSibling) {
                    nextSibling.classList.add('pl-4');
                    nextSibling.style.fontWeight = '600';
                    nextSibling.classList.remove('ui-sortable-handle');
                }
                svgElement.parentElement.remove();
            }
        });
    }

    // #display-optionsを非表示にする処理
    if (hideDisplayOptions) {
        const displayOptions = document.getElementById('display-options');
        if (displayOptions) {
            displayOptions.style.display = 'none';
        }
    }
}
